import { useContext } from "react";
import { LayoutBarContext } from "../../../contexts";
import ProfilHome from "../../Profil/ProfilHome";
import Profil from "../../UIElements/Profil";

export default function CustomProfil() {
    const { updateContent } = useContext(LayoutBarContext);
    return (
        <Profil
            boxProps={{
                sx: {
                    float: "right",
                },
            }}
            onProfilClick={() => {
                updateContent(<ProfilHome />);
            }}
        />
    );
}
